(function(Drupal, $, once) {
  'use strict';

  // For the Newsletter Signup form on the homepage footer banner.
  Drupal.behaviors.newsletterSignup = {
    attach: function(context, settings) {

      $(once('newsletter-signup', '#homepageNewsletterSignup', context)).each(function() {
        const $thisForm = jQuery(this);

        // On submit go to the form page and prefill the email address:
        $thisForm.on('submit', function(event) {
          event.preventDefault();
          let params = $thisForm.serialize();
          window.location.href = '/form/sign-up-for-updates?' + params;
        });
      });
    }
  };

})(Drupal, jQuery, once);
